import { Button, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { useFormContext } from '../Context/Context';
import { defaultDataCondition } from '../Constant/ThankYouModal';
import { useUrlThankYouMessage } from '../Context/UrlThankYouMessageContext';
import { useThankYouMessageStatus } from '../Context/ThankYouMessageStatusContext';
import { ThankYouConditionEditorContext } from '../Context/ThankYouConditionEditorContext';
import { ThankYouMessageContext } from '../Context/ThankYouMessageContext';
import { useContext } from 'react';
import { useThankYouMessageContent } from '../Context/ThankYouMessageContentContext';

const ThankYouModal = () => {


    const { finalPayload } = useContext(ThankYouConditionEditorContext);
    const { showThankYouMessage, setShowThankYouMessage } = useContext(ThankYouMessageContext);
    const { urlThankYouMessage } = useUrlThankYouMessage();
    const { thankYouMessageStatus, setThankYouMessageStatus } = useThankYouMessageStatus();
    const { thankYouMessageContent, setThankYouMessageContent } = useThankYouMessageContent();



    const navigate = useNavigate();


    const handleClose = () => {
        setShowThankYouMessage(false);
        navigate('/main');
    };

    useEffect(() => {
        if (thankYouMessageStatus === 'url') {
            window.open(urlThankYouMessage, '_blank', 'noopener,noreferrer');
            navigate('/main');
            setThankYouMessageStatus(null)
        }
    }, [thankYouMessageStatus, urlThankYouMessage, navigate]);

    // Render the modal only for custom message

    return (

        thankYouMessageStatus === 'message' &&
        <Grid
            width="100%"
            height="100vh"
            position="fixed"
            right={0}
            top={0}
            bgcolor="#44444E"
            display="flex"
            alignItems="center"
            justifyContent="center"
            zIndex={100000}
        >
            <Grid
                width="80%"
                height="60%"
                bgcolor="white"
                borderRadius="8px"
                pb="48px"
                position="relative"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
            >
                <Grid position="absolute" left="20px" top="20px" onClick={handleClose}>
                    <CloseIcon fontSize="large" style={{ color: 'black', cursor: 'pointer' }} />
                </Grid>

                {/* Render custom message */}
                <div dangerouslySetInnerHTML={{ __html: thankYouMessageContent }} />

                <Grid mt={2}>
                    <Button variant="contained" onClick={handleClose}>
                        <Typography>بستن</Typography>
                    </Button>
                </Grid>
            </Grid>
        </Grid>


    );
};

export default ThankYouModal;
